import React from 'react';

import FormInput from '../input/FormInput';
import { Divider, Grid, Typography } from '@mui/material';
import CompoundAddition from '../input/compound/CompoundAddition';

function TotalsTable({ name, classes, products }) {
    return (
        <>
            {classes.map((cl) => {
                return <ClassRow key={JSON.stringify(cl)} classRow={cl} products={products} name={name} />;
            })}
            <Divider />
            <TotalRow name={name} products={products} classes={classes} />
        </>
    );
}

const ClassRowSx = {
    display: 'flex',
    alignItems: 'center',
};

const RowItem = {
    margin: (theme) => theme.spacing(1),
};

function ClassRow({ name, classRow, products }) {
    return (
        <Grid container sx={ClassRowSx}>
            <Grid item xs sx={RowItem}>
                <Typography variant="body1" fontWeight="bold">
                    {classRow.props.label}
                </Typography>
            </Grid>
            {products.map(({ name: productName, props }) => {
                const productProps = {
                    name: `${name}.${classRow.name}.${productName}`,
                    props,
                };
                return (
                    <Grid item xs sx={RowItem} key={productProps.name}>
                        <FormInput {...productProps} />
                    </Grid>
                );
            })}
        </Grid>
    );
}

function TotalRow({ name, products, classes }) {
    return (
        <Grid container sx={ClassRowSx}>
            <Grid item xs sx={RowItem}>
                <Typography variant="body1" fontWeight="bold">
                    Total
                </Typography>
            </Grid>
            {products.map((prod) => {
                const prodProps = {
                    name: `${prod.name}-total`,
                    props: {
                        variant: 'outlined',
                        ...prod.props,
                        disabled: true,
                        type: 'string',
                        valueAsNumber: false,
                        formatNumberWithCommas: true,
                    },
                    references: classes.map((cl) => `${name}.${cl.name}.${prod.name}`),
                    calculateOnRender: true,
                };
                return (
                    <Grid item xs sx={RowItem} key={prod.label}>
                        <CompoundAddition {...prodProps} />
                    </Grid>
                );
            })}
        </Grid>
    );
}

export default TotalsTable;
